var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PlateTitle',{attrs:{"title":"保费发票","subtitle":"（电子发票1～2个工作日，纸质发票3～5个工作日）"}}),_c('div',{staticClass:"withApply"},[_c('img',{attrs:{"src":require("./image/icon-inbox.png"),"alt":""}}),_c('div',{staticClass:"tips"},[_vm._v(" 当前未申请发票 ")]),_c('a-button',{staticClass:"btn",attrs:{"type":"primary"}},[_vm._v(" 申请发票 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }